import React from "react";
import {
  Grid,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";

const Loading = () => {
  return (
    <Grid container justifyContent={"center"} mb={4}>
      <Grid
        item
        xs={12}
        md={10}
        mt={2}
        sx={{ bgcolor: "white", overflowX: "auto", maxHeight: "500px" }}
      >
        <Grid
          padding={"0px 25px"}
          position="sticky"
          top={0}
          backgroundColor="white"
          zIndex={1}
          pt={2}
        >
          <Typography variant="h5">List of Departments</Typography>
          <Skeleton variant="text" width={210} height={40} />
        </Grid>
        <TableContainer
          sx={{ padding: "25px", boxShadow: "0px 0px 0px" }}
          component={Paper}
        >
          <Table sx={{ minWidth: 650 }} aria-label="departments table">
            <TableHead style={{ backgroundColor: "#f2f2f2" }}>
              <TableRow>
                <TableCell>
                  <Skeleton variant="text" />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from(new Array(5)).map((_, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" width={100} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={50} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default Loading;
